import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./styles/admin-ui.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { register, unregister } from './serviceWorkerRegistration';
if (process.env.NODE_ENV === 'production') {
  register();
} else {
  unregister();
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />

  </>
);

reportWebVitals();
